module.exports = __webpack_public_path__ + "static/media/6585-r.3f5749dd.png";